var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isPay != true)?_c('v-icon',{attrs:{"small":"","color":"amber"}},[_vm._v("mdi-star-shooting")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }